import { PlGridColumn } from 'pl-core-services';

export const studentColumns: { [key: string]: PlGridColumn } = {
  firstName: {
    key: 'firstName',
    label: 'First Name',
    style: { width: '250px' },
  },
  lastName: { key: 'lastName', label: 'Last Name', style: { width: '250px' } },
  grade: {
    key: 'gradeDisplay',
    label: 'Grade',
    style: { className: 'pl-3 pr-3', width: '100px' },
  },
  school: { key: 'school', label: 'Location' },
  iep: {
    key: 'iepEndDate',
    type: 'date',
    label: 'IEP Due',
    style: { className: 'pl-3 pr-3', width: '105px' },
  },
  disability: { key: 'primaryDisability', label: 'Primary Disability' },
  provider: {
    key: 'provider',
    label: 'Provider',
  },
  provider_occupation: {
    key: 'provider_occupation',
    label: 'Occupation',
  },
};

export const baseColumns: PlGridColumn[] = [
  studentColumns['firstName'],
  studentColumns['lastName'],
  studentColumns['grade'],
  studentColumns['school'],
  studentColumns['iep'],
  {
    key: 'triennialEvalDate',
    type: 'date',
    label: 'Triennial Due',
    style: { className: 'pl-3 pr-3', width: '105px' },
  },
  studentColumns['disability'],
];
